export enum EPortee {
    Touscanaux = 1,
    CanalErecteur,
    CanalAirEau,
    CanalOperateur,
    CanalAspirateur,
    CanalAuxiliaire,
    CanalExtremiteDistale,
    Total,
    CanalWaterJet,
}